import React from 'react'
import { IonCol, IonItem, IonLabel, IonRange, IonRow } from '@ionic/react'
import NumPadToggleBox from '../../../../../../components/numPadToggleBox/NumPadToggleBox.component'
import { filterOutObjectKeys } from '../../../../../../utilities/object.util'
import { findMatchingObject, handleArrOperations, sumByKey } from '../../../../../../utilities/array.utils'
import { IBurnsState, IBurnsButtonOptions, IBurnsButtonOption, IObject } from '../../store/burns.types'
import { useDispatch, useSelector } from 'react-redux'
import { getBurnsSelector } from '../../selectors'
import {
  setBodyAreaCalculations,
  setBurnExams,
  saveBurns,
  setCurrentSelectedObj,
  setRange,
} from '../../store/burns.actions'
import { hyphenDotKeys } from '../../../../../../components/numberPad/NumberPad.types'

const totalValidations: IObject = {
  2: 4.5,
  37: 4.5,
  38: 4.5,
  5: 9,
  8: 9,
  9: 9,
  65: 9,
  66: 9,
  83: 1,
}

const Buttonwall = (props: {
  buttonArr: IBurnsButtonOptions
  rowTitle: string
  locationId: number
  selectorRef: any
}) => {
  const { buttonArr, rowTitle, locationId, selectorRef } = props
  const burnsStateData: IBurnsState = useSelector(getBurnsSelector)
  const { burnsExamData, __currentSelectedObj, __range } = burnsStateData
  const dispatch = useDispatch()

  const handleOnChange = (numValue: number, buttonsObj: IBurnsButtonOption | null) => {
    const values = String(numValue)
    const selectorObj = filterOutObjectKeys(buttonsObj, ['type', 'locationId', 'burnType'], 'filterin')
    const currentVal = findMatchingObject(burnsExamData, selectorObj)
    const updatedButtonObj: any = { ...buttonsObj, burnPercentage: values }

    let arr: IBurnsButtonOptions = [...burnsExamData]
    if (currentVal === -1) {
      arr = handleArrOperations(burnsExamData, updatedButtonObj, 'ADD')
    } else {
      arr = [...burnsExamData]
      if (numValue) {
        arr = handleArrOperations(burnsExamData, updatedButtonObj, 'UPDATE', selectorObj)
      } else {
        arr = handleArrOperations(burnsExamData, updatedButtonObj, 'DELETE', selectorObj)
      }
    }

    dispatch(setBurnExams(arr))
    dispatch(setBodyAreaCalculations())
    dispatch(saveBurns())
  }

  const handleOnRangeChange = (e: CustomEvent) => {
    dispatch(setRange(e.detail.value))
    handleOnChange(e.detail.value, __currentSelectedObj)
  }

  const formatValue = (value: number) => {
    return value.toFixed(1) // Format the value to one decimal place
  }

  const showSliderComponent =
    __currentSelectedObj && Object.keys(__currentSelectedObj).length && __currentSelectedObj.locationId === locationId

  const SUM_KEY = 'burnPercentage'
  const currentLocationId = Number(__currentSelectedObj?.locationId)
  const currentType = String(__currentSelectedObj?.type)
  const totalSum = sumByKey(burnsExamData, SUM_KEY, {
    locationId: [currentLocationId],
    type: [currentType],
  })
  const selectorObj =
    __currentSelectedObj && filterOutObjectKeys(__currentSelectedObj, ['type', 'locationId', 'burnType'], 'filterin')
  const currentVal = selectorObj && findMatchingObject(burnsExamData, selectorObj)
  const numberPadValues = currentVal?.burnPercentage || ''

  const netSum = totalSum - numberPadValues
  return (
    <>
      <IonRow className='w-100 mb-5'>
        <IonRow className='w-100 wall-margin'>
          <IonCol>
            <IonLabel>{rowTitle}</IonLabel>
          </IonCol>
          <IonCol className='ion-text-end ion-font-'>
            <IonLabel color='medium'>{totalValidations[locationId] + '%'}</IonLabel>
          </IonCol>
        </IonRow>
        <IonRow className='w-100 button-align '>
          {buttonArr?.map((buttons: IBurnsButtonOption) => {
            const { label, unitLabel, locationId, type } = buttons
            const selectorObj = filterOutObjectKeys(buttons, ['type', 'locationId', 'burnType'], 'filterin')
            const currentVal = findMatchingObject(burnsExamData, selectorObj)
            const numberPadValues = currentVal?.burnPercentage || ''
            const totalSum = sumByKey(burnsExamData, SUM_KEY, {
              locationId: [locationId],
              type: [type],
            })
            const disabled = totalValidations[locationId] - totalSum === 0 && !numberPadValues
            const currentSelected = JSON.stringify(__currentSelectedObj) === JSON.stringify(buttons) && !disabled
            return (
              <NumPadToggleBox
                key={label + locationId + type}
                disabled={disabled}
                className={currentSelected ? 'border-primary' : ''}
                numberPadValues={numberPadValues ? numberPadValues?.split('') : []}
                score={numberPadValues}
                label={label}
                unitLabel={unitLabel}
                validCharacters={hyphenDotKeys}
                isNumberPadEnabled={false}
                onClickAction={() => {
                  if (!disabled) {
                    dispatch(setCurrentSelectedObj(buttons))
                    if (numberPadValues) dispatch(setRange(numberPadValues))
                  }
                }}
              />
            )
          })}
        </IonRow>

        {showSliderComponent && (
          <IonRow className='w-100'>
            <IonCol>
              <IonItem color='light' className='ion-range-item'>
                <IonLabel className='range-initial-label'>0</IonLabel>
                <IonRange
                  id='custom-slider'
                  className='custom-range-slider'
                  ref={selectorRef}
                  color='primary'
                  min={0}
                  max={totalValidations[locationId] - netSum}
                  ticks={true}
                  step={0.5}
                  snaps={true}
                  pin={true}
                  pinFormatter={formatValue}
                  value={__range}
                  onIonChange={handleOnRangeChange}
                  debounce={100}
                />
                <IonLabel slot='end'>{totalValidations[locationId] - netSum}</IonLabel>
              </IonItem>
            </IonCol>
          </IonRow>
        )}
      </IonRow>
      <hr className='w-100 bg-white p-1' />
    </>
  )
}

export default Buttonwall
